import * as functions from '../pagination/paginationActions';

const pagination = {
    ...functions
};

export default pagination;